import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot/index";
import axios from "axios";

// get notes 
export const getNotes = createAsyncThunk("notes/get-notes ", async (data) => {
    const token = localStorage.getItem("authToken")
    console.log(" notes Redux id" ,{data})
    try {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/notes/app/v1/get-notes/${data.id}`, {page : data.page}, { 
            headers: {
                "auth-token": token,
            }
        },);
        console.log({ response })
        return response;
    } catch (error) {
        console.error('Error fetching notes - ', error);
        throw error;
    }
})


